export enum ClientTaskHistoryItemActions {
  created = 'created',
  submitted = 'submitted',
  transitioned = 'transitioned',
}
